module.exports = __webpack_public_path__ + "img/shape-9@2x.19d5b307.png";